import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

/**
 * `online` and `away` are the backend's presence; `invisible` keeps the socket closed so the
 * member never counts as connected, and the inbox polls instead.
 */
export type AgentStatus = 'online' | 'away' | 'invisible';

interface InboxPrefs {
  status: AgentStatus;
  sound: boolean;
  desktop: boolean;
  setStatus: (status: AgentStatus) => void;
  setSound: (sound: boolean) => void;
  setDesktop: (desktop: boolean) => void;
}

/** Remembered per browser (D-103 LC3): status, sound and desktop alerts are opt-in UI state. */
export const useInboxPrefs = create<InboxPrefs>()(
  persist(
    (set) => ({
      status: 'online',
      sound: false,
      desktop: false,
      setStatus: (status) => set({ status }),
      setSound: (sound) => set({ sound }),
      setDesktop: (desktop) => set({ desktop }),
    }),
    {
      name: 'nucleus:inbox:prefs',
      storage: createJSONStorage(() => localStorage),
      partialize: ({ status, sound, desktop }) => ({ status, sound, desktop }),
    },
  ),
);
